export default "__VITE_ASSET__DBbR1T17__"